<template>
  <div id="members-subscrition-assign">

    <!-- ─── Dialog: Add New Member ─── -->
    <v-dialog v-model="addRecordPrompt" persistent max-width="600px">
      <add-new-member pageDescription="Create Staff" :addRecordPrompt="addRecordPrompt" :recordData="editRecordData"
        :editIndex="editIndex" @hideAddRecordPrompt="addNewMember($event)" v-if="addRecordPrompt"></add-new-member>
    </v-dialog>

    <!-- ─── Premium Header Card ─── -->
    <v-card elevation="20" class="header-card mb-6 overflow-hidden">
      <div class="header-gradient">
        <div class="header-backdrop-effect"></div>
        <div class="header-content pa-8">
          <v-row align="center" justify="space-between">
            <!-- Left: Icon + Title -->
            <v-col cols="12" md="8" class="d-flex align-center">
              <div class="header-icon-box">
                <v-icon size="40px" color="white">mdi-wallet</v-icon>
              </div>
              <div class="ml-5">
                <h1 class="header-title white--text mb-1">Members Subscription Assign</h1>
                <p class="header-subtitle white--text mb-0">
                  <v-icon small color="rgba(255,255,255,0.8)" class="mr-1">mdi-information-outline</v-icon>
                  Assign pending subscriptions to LOM members
                </p>
              </div>
            </v-col>
            <!-- Right: Action Buttons -->
            <v-col cols="12" md="4" class="d-flex justify-end align-center" style="gap:10px">
              <v-btn class="action-btn" elevation="0" @click="refreshPageData" title="Refresh">
                <v-icon left>mdi-refresh</v-icon> Refresh
              </v-btn>
              <v-btn class="action-btn" elevation="0" @click="backPage" title="Go Back">
                <v-icon left>mdi-arrow-left</v-icon> Back
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>

    <!-- ─── Speed Dial (floating add button) ─── -->
    <v-container class="py-0">
      <v-speed-dial v-if="FloatingButtonFlag" v-model="fab" :top="top" :bottom="bottom" :right="right" :left="left"
        :direction="direction" :open-on-hover="hover" :transition="transition" :fixed="true">
        <template v-slot:activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-btn fab dark small color="indigo" @click.prevent="addRecordPrompt = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-container>

    <v-form ref="form2" v-model="valid2" lazy-validation>

      <!-- ─── Skeleton loader ─── -->
      <v-container class="py-0" v-if="StartupLoadingFlag">
        <v-skeleton-loader v-bind="attrs" type="table-tbody"></v-skeleton-loader>
      </v-container>

      <!-- ─── Main Content ─── -->
      <v-container class="py-0" v-if="!StartupLoadingFlag">

        <!-- Year / Contribution Type Title -->
        <div class="section-title-bar mb-4" v-if="rows.YearName">
          <v-icon color="#0097D7" class="mr-2">mdi-calendar-check</v-icon>
          <span>{{ rows.YearName }} — {{ rows.ContributionTypeDescription }}</span>
        </div>

        <!-- Stat Cards Row -->
        <v-row class="mb-4">
          <v-col cols="12" md="4">
            <div class="stat-card stat-paid">
              <div class="stat-icon-wrap">
                <v-icon size="36" color="white">mdi-receipt</v-icon>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ rows.PaidCount }}</div>
                <div class="stat-label">Subscriptions Paid</div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="stat-card stat-selected">
              <div class="stat-icon-wrap">
                <v-icon size="36" color="white">mdi-account-check</v-icon>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ rows.SelelctedCount }}</div>
                <div class="stat-label">Already Selected</div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="stat-card stat-remaining">
              <div class="stat-icon-wrap">
                <v-icon size="36" color="white">mdi-account-clock</v-icon>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ rows.RemainingCount }}</div>
                <div class="stat-label">Remaining to Assign</div>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Notes Panel -->
        <v-card class="notes-card mb-5" elevation="0">
          <div class="notes-header">
            <v-icon color="#1565C0" class="mr-2">mdi-lightbulb-on-outline</v-icon>
            <span class="notes-title">Important Instructions</span>
          </div>
          <v-divider class="mb-3"></v-divider>
          <ul class="notes-list">
            <li>
              <v-icon small color="#0097D7" class="mr-2">mdi-account-tie</v-icon>
              <strong>Tab 1</strong> — Shows members from the <em>previous half</em> who are eligible.
            </li>
            <li>
              <v-icon small color="#0097D7" class="mr-2">mdi-account-group</v-icon>
              <strong>Tab 2</strong> — Shows <em>all other existing</em> members of the LOM.
            </li>
            <li>
              <v-icon small color="#0097D7" class="mr-2">mdi-account-plus</v-icon>
              <strong>Tab 3</strong> — Used to <em>create new members</em> to your LOM.
            </li>
            <li>
              <v-icon small color="#43A047" class="mr-2">mdi-identifier</v-icon>
              New members will receive their <strong>Membership ID immediately</strong> after creation.
            </li>
            <li>
              <v-icon small color="#E53935" class="mr-2">mdi-alert-circle-outline</v-icon>
              The total across all tabs <strong>cannot exceed</strong> the total subscription paid. The same member
              cannot be marked twice.
            </li>
            <li>
              <v-icon small color="#FB8C00" class="mr-2">mdi-checkbox-multiple-marked-outline</v-icon>
              Selection can be <strong>done partially</strong>. You may assign remaining members later.
            </li>
          </ul>
        </v-card>

        <!-- ─── Tabs ─── -->
        <v-tabs v-model="tab" background-color="#3a67b1" centered dark icons-and-text show-arrows
          class="premium-tabs mb-2">
          <v-tabs-slider color="#0097D7"></v-tabs-slider>
          <v-tab href="#tab-1" :disabled="TabDisable1">
            Previous Half Members
            <v-icon>mdi-account-tie</v-icon>
          </v-tab>
          <v-tab href="#tab-2" :disabled="TabDisable2">
            Existing Members
            <v-icon>mdi-account-group</v-icon>
          </v-tab>
          <v-tab href="#tab-3" :disabled="TabDisable3" v-if="rows.NewMembersFlag == 1">
            Add New Members
            <v-icon>mdi-account-plus</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">

          <!-- ── Tab 1: Previous Half Members ── -->
          <v-tab-item value="tab-1">
            <v-card flat class="tab-content-card">
              <div class="tab-section-header">
                <v-icon color="#1A237E" class="mr-2">mdi-account-tie</v-icon>
                <span>Select Members from the Previous Half</span>
              </div>

              <div v-if="!LoadingFlag && ResultFlag && PreviousHalfMembers.length == 0" class="empty-state">
                <v-icon size="56" color="grey lighten-1">mdi-account-search-outline</v-icon>
                <p class="mt-3 grey--text">No previous half members found.</p>
              </div>

              <div v-if="PreviousHalfMembers.length > 0">
                <div class="table-count-bar">
                  <v-icon small color="#0097D7" class="mr-1">mdi-account-multiple</v-icon>
                  <strong>{{ PreviousHalfMembers.length }}</strong>&nbsp;members found
                  &nbsp;|&nbsp;
                  <v-icon small color="#43A047" class="mr-1">mdi-check-all</v-icon>
                  <strong>{{ selected1.length }}</strong>&nbsp;selected
                </div>
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="Search previous half members..."
                  single-line hide-details outlined dense class="search-field mb-3">
                </v-text-field>
                <v-data-table class="premium-table" v-model="selected1" :headers="tableColumns1"
                  :items="PreviousHalfMembers" :items-per-page="50" :search="search" item-key="DuesId"
                  :single-select="false" :show-select="true" :item-class="getRowClass" :footer-props="{
                    'items-per-page-options': [10, 20, 30, 40, 50],
                  }">
                  <!-- Disable checkbox for age-restricted rows -->
                  <template v-slot:item.data-table-select="{ item, isSelected, select }">
                    <v-simple-checkbox :value="isSelected" :disabled="item.AgeRestrictionFlag === true" :ripple="false"
                      @input="item.AgeRestrictionFlag ? null : select($event)"></v-simple-checkbox>
                  </template>
                  <template v-slot:item.ActiveStatusTxt="{ item }">
                    <v-chip :color="getActiveStatusColor(item.ActiveStatusTxt)" small dark label>
                      <v-icon x-small left>mdi-circle</v-icon>
                      {{ item.ActiveStatusTxt }}
                    </v-chip>
                  </template>
                  <template v-slot:item.AadhaarVerifiedTxt="{ item }">
                    <v-chip :color="item.AadhaarVerifiedColor" small dark label>
                      <v-icon x-small left>{{ item.AadhaarVerifiedColor === 'green' ? 'mdi-shield-check' :
                        'mdi-shield-off-outline' }}</v-icon>
                      {{ item.AadhaarVerifiedTxt }}
                    </v-chip>
                  </template>
                  <template v-slot:item.MemberImagePath="{ item }">
                    <v-avatar size="50" class="my-2" style="border:2px solid #E3F2FD">
                      <img :src="item.MemberImagePath" :alt="item.MemberName" style="object-fit:cover" />
                    </v-avatar>
                  </template>
                  <template v-slot:item.MemberName="{ item }">
                    <div class="member-name-cell">
                      <span class="member-name-text">{{ item.MemberName }}</span>
                      <div v-if="item.AgeRestrictionFlag" class="age-warning-chip">
                        <v-icon x-small color="white" class="mr-1">mdi-alert</v-icon>
                        40+ years old &bull; Not eligible for JCI Membership
                      </div>
                    </div>
                  </template>
                  <template v-slot:item.MemberDob="{ item }">
                    <v-chip :color="item.DobColor" small dark label>
                      <v-icon x-small left>mdi-calendar-account</v-icon>
                      {{ item.MemberDob }}
                    </v-chip>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small color="blue" @click="previewData(item, e)" v-bind="attrs" v-on="on"
                          v-if="item.ActiveStatus == 2">
                          <v-icon small>mdi-clipboard-text-search</v-icon>
                        </v-btn>
                      </template>
                      <span>Preview</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small color="orange" @click="editAlert(item, e)" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-file-document-edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </div>
            </v-card>
          </v-tab-item>

          <!-- ── Tab 2: Existing Members ── -->
          <v-tab-item value="tab-2">
            <v-card flat class="tab-content-card">
              <div class="tab-section-header">
                <v-icon color="#1A237E" class="mr-2">mdi-account-group</v-icon>
                <span>Select from All Other Members of the LOM</span>
              </div>

              <div v-if="!LoadingFlag && ResultFlag && ExistingMembers.length == 0" class="empty-state">
                <v-icon size="56" color="grey lighten-1">mdi-account-search-outline</v-icon>
                <p class="mt-3 grey--text">No existing members found.</p>
              </div>

              <div v-if="ExistingMembers.length > 0">
                <div class="table-count-bar">
                  <v-icon small color="#0097D7" class="mr-1">mdi-account-multiple</v-icon>
                  <strong>{{ ExistingMembers.length }}</strong>&nbsp;members found
                  &nbsp;|&nbsp;
                  <v-icon small color="#43A047" class="mr-1">mdi-check-all</v-icon>
                  <strong>{{ selected2.length }}</strong>&nbsp;selected
                </div>
                <v-text-field v-model="search2" prepend-inner-icon="mdi-magnify" label="Search existing members..."
                  single-line hide-details outlined dense class="search-field mb-3">
                </v-text-field>
                <v-data-table class="premium-table" v-model="selected2" :headers="tableColumns2"
                  :items="ExistingMembers" :items-per-page="50" :search="search2" :footer-props="{
                    'items-per-page-options': [10, 20, 30, 40, 50, -1],
                  }" item-key="MemberId" :single-select="false" :show-select="true" :item-class="getRowClass">
                  <!-- Disable checkbox for age-restricted rows -->
                  <template v-slot:item.data-table-select="{ item, isSelected, select }">
                    <v-simple-checkbox :value="isSelected" :disabled="item.AgeRestrictionFlag === true" :ripple="false"
                      @input="item.AgeRestrictionFlag ? null : select($event)"></v-simple-checkbox>
                  </template>
                  <template v-slot:item.ActiveStatusTxt="{ item }">
                    <v-chip :color="getActiveStatusColor(item.ActiveStatusTxt)" small dark label>
                      <v-icon x-small left>mdi-circle</v-icon>
                      {{ item.ActiveStatusTxt }}
                    </v-chip>
                  </template>
                  <template v-slot:item.AadhaarVerifiedTxt="{ item }">
                    <v-chip :color="item.AadhaarTextColor" small dark label>
                      <v-icon x-small left>{{ item.AadhaarTextColor === '#4CAF50' ? 'mdi-shield-check' :
                        'mdi-shield-off-outline' }}</v-icon>
                      {{ item.AadhaarVerifiedTxt }}
                    </v-chip>
                  </template>
                  <template v-slot:item.ProfilePic="{ item }">
                    <v-avatar size="50" class="my-2" style="border:2px solid #E3F2FD">
                      <img :src="item.ProfilePic" :alt="item.MemberName" style="object-fit:cover" />
                    </v-avatar>
                  </template>
                  <template v-slot:item.MemberName="{ item }">
                    <div class="member-name-cell">
                      <span class="member-name-text">{{ item.MemberName }}</span>
                      <div v-if="item.AgeRestrictionFlag" class="age-warning-chip">
                        <v-icon x-small color="white" class="mr-1">mdi-alert</v-icon>
                        40+ years old &bull; Not eligible for JCI Membership
                      </div>
                    </div>
                  </template>
                  <template v-slot:item.MemberDob="{ item }">
                    <v-chip :color="item.DobColor" small dark label>
                      <v-icon x-small left>mdi-calendar-account</v-icon>
                      {{ item.MemberDob }}
                    </v-chip>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small color="orange" @click="editAlert(item, e)" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-file-document-edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </div>
            </v-card>
          </v-tab-item>

          <!-- ── Tab 3: Add New Members ── -->
          <v-tab-item value="tab-3" v-if="rows.NewMembersFlag == 1">
            <v-card flat class="tab-content-card">
              <div class="tab-section-header">
                <v-icon color="#1A237E" class="mr-2">mdi-account-plus</v-icon>
                <span>Add New Members to the LOM</span>
                <v-btn icon small color="#0097D7" class="ml-auto" @click.prevent="addRecordPrompt = true"
                  title="Add Member">
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </div>
              <div class="elevation-2 rounded-lg mx-4 mb-4 mt-2" style="border: 1px solid #e0e0e0; overflow: hidden;">
                <v-simple-table class="new-member-table" style="background-color: #ffffff;">
                  <template>
                    <thead style="background: linear-gradient(90deg, #f8f9fa 0%, #e9ecef 100%);">
                      <tr>
                        <th class="text-left py-3 font-weight-bold" style="color: #495057; font-size: 15px;"><v-icon
                            small color="#1db954" class="mr-2">mdi-account</v-icon>Member Name</th>
                        <th class="text-left py-3 font-weight-bold" style="color: #495057; font-size: 15px;"><v-icon
                            small color="#1a73e8" class="mr-2">mdi-email-outline</v-icon>Email</th>
                        <th class="text-left py-3 font-weight-bold" style="color: #495057; font-size: 15px;"><v-icon
                            small color="#ff9800" class="mr-2">mdi-phone</v-icon>Mobile No</th>
                        <th class="text-left py-3 font-weight-bold" style="color: #495057; font-size: 15px;"><v-icon
                            small color="#e91e63" class="mr-2">mdi-map-marker</v-icon>Address</th>
                        <th class="text-center py-3 font-weight-bold" style="color: #495057; font-size: 15px;">Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, k) in NewMembers" :key="k" class="new-member-row"
                        style="transition: all 0.3s ease;">
                        <td class="py-3">
                          <div class="d-flex align-center">
                            <v-avatar size="44" color="#e3f2fd" class="mr-3" style="border: 2px solid #bbdefb">
                              <span style="color: #1976d2; font-weight: bold; font-size: 18px;">{{ item.MemberName ?
                                item.MemberName.charAt(0).toUpperCase() : 'U' }}</span>
                            </v-avatar>
                            <div>
                              <strong style="color: #2c3e50; font-size: 15px;">{{ item.MemberName }}</strong>
                              <div v-if="item.MemberGender == 1" class="text-caption grey--text mt-1"><v-icon x-small
                                  color="blue" class="mr-1">mdi-gender-male</v-icon>Male</div>
                              <div v-else-if="item.MemberGender == 2" class="text-caption grey--text mt-1"><v-icon
                                  x-small color="pink" class="mr-1">mdi-gender-female</v-icon>Female</div>
                              <div v-else-if="item.MemberGender == 3" class="text-caption grey--text mt-1"><v-icon
                                  x-small color="purple" class="mr-1">mdi-gender-transgender</v-icon>Others</div>
                            </div>
                          </div>
                        </td>
                        <td class="py-3" style="color: #546e7a;">{{ item.MemberEmail || 'N/A' }}</td>
                        <td class="py-3">
                          <v-chip outlined small color="primary" class="font-weight-medium bg-light">
                            <v-icon left small>mdi-phone-outline</v-icon>{{ item.MemberMobileNo }}
                          </v-chip>
                        </td>
                        <td class="td-city py-3" style="color: #546e7a;">
                          <div class="d-flex align-start">
                            <v-icon small color="grey" class="mr-1 mt-1">mdi-map-marker-outline</v-icon>
                            <p v-html="item.MemberAddressTxt" style="font-size:13px; line-height: 1.4; margin:0"></p>
                          </div>
                        </td>
                        <td class="text-center py-3">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon color="orange darken-2" @click.prevent="editNewMember(item, k)" elevation="1"
                                class="mx-1 mt-1" style="background-color: #fff8e1;" v-bind="attrs" v-on="on">
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit Member</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon color="red darken-2" @click="deleteRow(2, k, item)" elevation="1"
                                class="mx-1 mt-1" style="background-color: #ffebee;" v-bind="attrs" v-on="on">
                                <v-icon small>mdi-delete-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete Member</span>
                          </v-tooltip>
                        </td>
                      </tr>
                      <tr v-if="NewMembers.length === 0">
                        <td colspan="5" class="text-center py-10" style="background-color: #fafbfc;">
                          <v-avatar size="80" color="#f5f5f5" class="mb-4" style="border: 2px dashed #cfd8dc;">
                            <v-icon size="40" color="#90a4ae">mdi-account-group-outline</v-icon>
                          </v-avatar>
                          <h3 class="grey--text text--darken-2 mb-2">No Members Added Yet</h3>
                          <p class="grey--text mb-5">Click the "Add Member" button above to add new members to the LOM.
                          </p>
                          <v-btn color="#1db954" dark rounded outlined @click.prevent="addRecordPrompt = true"
                            class="px-6 font-weight-bold">
                            <v-icon left>mdi-plus-circle</v-icon> Add First Member
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card>
          </v-tab-item>

        </v-tabs-items>

        <br /><br />
      </v-container>

      <!-- ─── Sticky Footer Bar ─── -->
      <v-footer :fixed="true" :absolute="false" :padless="true" class="premium-footer">
        <div class="footer-inner">
          <!-- Stats Row: centered -->
          <div class="footer-stats-row">
            <span class="footer-stat" @click="tab = 'tab-1'">
              <v-icon small class="mr-1">mdi-account-tie</v-icon>
              Prev Half: <strong>{{ selected1.length }}</strong>
            </span>
            <span class="footer-divider">•</span>
            <span class="footer-stat" @click="tab = 'tab-2'">
              <v-icon small class="mr-1">mdi-account-group</v-icon>
              Existing: <strong>{{ selected2.length }}</strong>
            </span>
            <span class="footer-divider">•</span>
            <span class="footer-stat" @click="tab = 'tab-3'">
              <v-icon small class="mr-1">mdi-account-plus</v-icon>
              New: <strong>{{ NewMembers.length }}</strong>
            </span>
            <span class="footer-divider">•</span>
            <span class="footer-stat total">
              <v-icon small class="mr-1">mdi-sigma</v-icon>
              Total: <strong>{{ TotalMembers }}</strong>&nbsp;/&nbsp;{{ rows.RemainingCount }}
            </span>
          </div>
          <!-- Submit Button: right end -->
          <v-btn :loading="SubmitFlag" color="#43A047" dark class="submit-btn" @click="submitConfirmAlert">
            <v-icon left>mdi-send</v-icon> Submit Assignment
          </v-btn>
        </div>
      </v-footer>

    </v-form>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import AddNewMember from "@/view/pages/erp/payment/AddNewMember.vue";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {
    AddNewMember,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      FloatingButtonFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,

      TabDisable1: false,
      TabDisable2: false,
      TabDisable3: false,

      rows: [],
      tableColumns1: [],
      tableColumns2: [],
      selected: [],
      search: "",
      search2: "",
      CurrentYearId: 0,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      editRecordData: {},
      editIndex: -1,

      zone: {},
      lom: {},
      LomPaymentId: "",
      PreviousHalfMembers: [],
      ExistingMembers: [],
      Member: {},

      selected1: [],
      selected2: [],
      NewMembers: [],
      TotalMembers: 0,

      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      FromZoneCodeRules: [(v) => !!v || "Zone is required"],
      FromZoneCode: "",
      FromZoneCodeOptions: [],
      FromZoneCodeOptionsLoading: false,

      FromLomCodeRules: [(v) => !!v || "LOM is required"],
      FromLomCode: "",
      FromLomCodeOptions: [],
      FromLomCodeOptionsLoading: false,

      ToZoneCodeRules: [(v) => !!v || "Zone is required"],
      ToZoneCode: "",
      ToZoneCodeOptions: [],
      ToZoneCodeOptionsLoading: false,

      ToLomCodeRules: [(v) => !!v || "LOM is required"],
      ToLomCode: "",
      ToLomCodeOptions: [],
      ToLomCodeOptionsLoading: false,

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],
      SearchIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "By LOM" },
        { value: 2, text: "By Membership Id" },
      ],

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership Id is required"],

      YearHalfId: "",
      YearHalfIdRules: [(v) => !!v || "Year Half is required"],
      YearHalfIdOptions: [
        { value: "", text: "--Select Half--" },
        { value: "First", text: "First Half" },
        { value: "Second", text: "Second Half" },
      ],

      YearIdRules: [(v) => !!v || "Year is required"],
      YearId: "",
      YearIdOptions: [],
      YearIdOptionsLoading: false,

      ApprovalDescription: "",
      ApprovalDescriptionRules: [],

      ConfirmButtonActionPage: "",
      CancelButtonActionPage: "",

      tab: null,

      icons: ["mdi-home", "mdi-email", "mdi-calendar", "mdi-delete"],
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
    selected1: function () {
      console.log("watch selected1");
      this.calculateTotalMembers();
    },
    selected2: function () {
      console.log("watch selected2");
      this.calculateTotalMembers();
    },
    NewMembers: function () {
      console.log("watch NewMembers");
      this.calculateTotalMembers();
    },
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    editNewMember(item, index) {
      console.log("editNewMember called");
      this.editRecordData = Object.assign({}, item);
      this.editIndex = index;
      this.addRecordPrompt = true;
    },
    addNewMember(payload) {
      console.log("addNewMember called");
      this.addRecordPrompt = false;
      console.log("Payload=" + JSON.stringify(payload));

      if (payload && payload.member) {
        let member = payload.member;
        let index = payload.index;

        if (index !== undefined && index > -1) {
          // Update existing member
          if (member && member.MemberFlag) {
            this.$set(this.NewMembers, index, member);
          }
        } else {
          // Add new member
          if (member && member.MemberFlag) {
            this.Member = member;
            this.addNewRow(2);
          }
        }
      }

      // Reset edit states
      this.editRecordData = {};
      this.editIndex = -1;
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form2.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    calculateTotalMembers() {
      console.log("calculateTotalMembers called");
      var c1 = this.selected1.length;
      var c2 = this.selected2.length;
      var c3 = this.NewMembers.length;
      console.log("c1=" + c1 + ", c2=" + c2 + ", c3=" + c3);
      var TotalMembers = parseInt(c1) + parseInt(c2) + parseInt(c3);
      console.log("TotalMembers=" + TotalMembers);
      this.TotalMembers = TotalMembers;
    },
    getRowClass(item) {
      return item.AgeRestrictionFlag === true ? 'row-age-restricted' : '';
    },
    addNewRow(tableId) {
      console.log("addNewRow called");
      console.log("tableId=" + tableId);

      if (tableId == 2) {
        var n1 = this.NewMembers.length;
        console.log("n1=" + n1);
        var MemberFlag = this.Member.MemberFlag;
        console.log("MemberFlag=" + MemberFlag);
        if (MemberFlag) {
          this.NewMembers.push(this.Member);
        }
        // if (n1 < 30) {
        this.Member = {};
        // }
        /*
        {
          MemberName: "",
          MemberMiddleName: "",
          MemberLastName: "",
          MemberEmail: "",
          MemberMobileNo: "",
          MemberAddress: "",
          MemberCity: "",
          MemberPincode: "",
        }
        */
      }
    },
    deleteRow(tableId, index, tr) {
      console.log("deleteRow called");
      console.log(
        "tableId=" + tableId + ", index=" + index + ", tr=" + JSON.stringify(tr)
      );
      if (index > -1) {
        if (tableId == 1) {
          this.AllDesignation.splice(index, 1);
        }
        if (tableId == 2) {
          this.NewMembers.splice(index, 1);
        }
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getTableRecords();
    },
    submitConfirmAlert() {
      Swal.fire({
        title: "Do you want to continue?",
        text: "Please verify all the information before proceeding.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Continue`,
        confirmButtonColor: "#3085d6",
        cancelButtonText: `Cancel`,
        cancelButtonColor: "#d33",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.submitForm();
        } else {
          this.sweetAlert("error", "You cancelled the process", true);
        }
      });
    },
    confirmAlert() {
      Swal.fire({
        title: "Awesome!",
        text: "Members selected successfully",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: `Go to Members list`,
        confirmButtonColor: "#3085d6",
        cancelButtonText: `Go to Subscription list`,
        cancelButtonColor: "#32a852",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // this.submitForm();
          this.$router.push(this.ConfirmButtonActionPage);
        } else {
          this.$router.push(this.CancelButtonActionPage);
          // this.sweetAlert("error", "You cancelled the process", true);
        }
      });
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var LomPaymentId = this.LomPaymentId;
      console.log("LomPaymentId=" + LomPaymentId);

      if (LomPaymentId != null) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-payment/show";
        var upload = {
          UserInterface: 1,
          LomPaymentId: LomPaymentId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.rows = [];
        this.ResultFlag = false;
        this.LoadingFlag = true;
        this.StartupLoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;
            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.rows = records;
              thisIns.getPreviousHalfMembers();
              thisIns.getAllMembers();
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "LOM should not be empty.";
        console.log("error=" + message);
      }
    },
    getPreviousHalfMembers() {
      console.log("getPreviousHalfMembers called");

      //   this.resetMessageTxt();
      this.selected1 = [];
      this.PreviousHalfMembers = [];

      var LomCode = this.rows.LomId;
      var YearCode = this.rows.YearId;
      var YearHalf = this.rows.YearHalf;
      var MemberType = this.rows.MemberTypeId;
      console.log(
        "LomCode=" +
        LomCode +
        ", YearCode=" +
        YearCode +
        ", YearHalf=" +
        YearHalf +
        ", MemberType=" +
        MemberType
      );

      if (LomCode != "" && YearCode != "" && YearHalf != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/member-dues/lists";
        var upload = {
          UserInterface: 1,
          LomCode: LomCode,
          YearCode: YearCode,
          YearHalf: YearHalf,
          MemberType: MemberType,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        // thisIns.pageLoadingOn()
        this.LoadingFlag = true;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.SuccessMessageTxtFlag = 1;
              thisIns.SuccessMessageTxt = output;
              thisIns.PreviousHalfMembers = records;
              thisIns.NewMembersFlag = true;
            } else {
              thisIns.ErrorMessageTxtFlag = 1;
              thisIns.ErrorMessageTxt = output;
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        this.ErrorMessageTxtFlag = 1;
        this.ErrorMessageTxt = "LOM should not be empty.";
      }
    },
    getAllMembers() {
      console.log("getAllMembers called");

      // this.resetMessageTxt();
      this.selected2 = [];
      this.ExistingMembers = [];

      var LomCode = this.rows.LomId;
      var YearCode = this.rows.YearId;
      var YearHalf = this.rows.YearHalf;
      var MemberType = this.rows.MemberTypeId;
      console.log(
        "LomCode=" +
        LomCode +
        ", YearCode=" +
        YearCode +
        ", YearHalf=" +
        YearHalf +
        ", MemberType=" +
        MemberType
      );

      if (LomCode != "" && YearCode != "" && YearHalf != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members";
        var upload = {
          UserInterface: 2,
          additional: {
            LomCode: LomCode,
            YearCode: YearCode,
            YearHalf: YearHalf,
            MemberTypeId: MemberType,
          },
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        // thisIns.pageLoadingOn()
        thisIns.ProgessStart = 1;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.ProgessStart = 0;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.SuccessMessageTxtFlag = 1;
              thisIns.SuccessMessageTxt = output;
              thisIns.ExistingMembers = records;
              thisIns.NewMembersFlag = true;
            } else {
              thisIns.ErrorMessageTxtFlag = 1;
              thisIns.ErrorMessageTxt = output;
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
          });
      } else {
        this.ErrorMessageTxtFlag = 1;
        this.ErrorMessageTxt = "LOM should not be empty.";
      }
    },
    getZoneCodeOptions(source, destination) {
      console.log("getZoneCodeOptions called");
      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      var CurrentYearId = this.CurrentYearId;
      console.log(
        "source=" +
        source +
        ", destination=" +
        destination +
        ", CurrentYearId=" +
        CurrentYearId
      );
      if (source != "" && destination != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: CurrentYearId,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getLomCodeOptions(source, destination, ZoneCode) {
      console.log("getLomCodeOptions called");
      console.log(
        "source=" +
        source +
        ", destination=" +
        destination +
        ", ZoneCode=" +
        ZoneCode
      );
      var CurrentYearId = this.CurrentYearId;
      if (ZoneCode != "" && CurrentYearId != "") {
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: CurrentYearId,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "Zone should not be empty";
        this.toast("error", message);
      }
    },
    getYearCodeOptions(source, destination) {
      console.log("getYearCodeOptions called");
      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      // var CurrentYearId = this.CurrentYearId;
      var CurrentYearId = 1;
      console.log(
        "source=" +
        source +
        ", destination=" +
        destination +
        ", CurrentYearId=" +
        CurrentYearId
      );
      if (source != "" && destination != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/jci-year/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    searchForm() {
      console.log("searchForm is called");

      var validate1 = this.$refs.form2.validate();
      var SearchId = this.SearchId;
      var UserInterface = SearchId == 1 ? 1 : 3;
      console.log(
        "validate1=" +
        validate1 +
        ", SearchId=" +
        SearchId +
        ", UserInterface=" +
        UserInterface
      );

      if (validate1) {
        this.SearchFlag = true;
        this.rows = [];
        this.zone = {};
        this.lom = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members";
        var upload = {
          UserInterface: UserInterface,
          additional: {
            MembershipId: this.MembershipId,
            LomCode: this.FromZoneCode,
            LomCode: this.FromLomCode,
          },
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.rows = records;
              thisIns.zone = response.data.zone;
              thisIns.lom = response.data.lom;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      var RemainingCount = this.rows.RemainingCount;
      console.log("RemainingCount=" + RemainingCount);

      var PreviousMembers = this.selected1;
      var n1 = PreviousMembers.length;
      console.log(
        "n1=" + n1 + ", PreviousMembers=" + JSON.stringify(PreviousMembers)
      );

      var NewMembers = this.NewMembers;
      var n2 = NewMembers.length;
      console.log("n2=" + n2 + ", NewMembers=" + JSON.stringify(NewMembers));

      var ExistingMembers = this.selected2;
      var n3 = ExistingMembers.length;
      console.log(
        "n3=" + n3 + ", ExistingMembers=" + JSON.stringify(ExistingMembers)
      );

      var TotalCount = parseInt(n1) + parseInt(n2) + parseInt(n3);
      console.log("TotalCount=" + TotalCount);

      // this.rows = [];

      if (validate1 && TotalCount <= RemainingCount && RemainingCount > 0) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-payment/assign-members";
        var upload = {
          LomPaymentId: this.LomPaymentId,
          PreviousMembers: PreviousMembers,
          ExistingMembers: ExistingMembers,
          NewMembers: NewMembers,
          TotalMembers: TotalCount,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.confirmAlert();
              // thisIns.$router.push("/lom/membership-list");
            } else {
              // thisIns.toast("error", output);
              thisIns.sweetAlert("info", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        if (TotalCount > RemainingCount && RemainingCount > 0) {
          message +=
            "You can select or create within " +
            RemainingCount +
            " members only. ";
        }
        if (RemainingCount == 0) {
          message += "Already you selected all members for this subscription. ";
        }
        this.sweetAlert("error", message, false);
        // this.toast("error", message);
      }
    },
  },
  beforeMount() {
    console.log(this.$route.query.id);
    this.LomPaymentId = this.$route.query.id;
    var CurrentYearId = this.$session.get("CurrentYearId");
    CurrentYearId = 1;
    CurrentYearId = CurrentYearId == (null || undefined) ? 0 : CurrentYearId;

    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? 0 : RoleId;

    if (RoleId == (1 || 2 || 4)) {
      this.ConfirmButtonActionPage = "/members/list";
      this.CancelButtonActionPage = "/lom/subscription/list";
    } else {
      this.ConfirmButtonActionPage = "/lom/membership-list";
      this.CancelButtonActionPage = "/members/subscription/list";
    }

    this.CurrentYearId = CurrentYearId;
    this.refreshPageData();
    this.tableColumns1.push(
      { text: "#", value: "sno" },
      { text: "Photo", value: "MemberImagePath" },
      { text: "Member Id", value: "MembershipId" },
      { text: "Member Name", value: "MemberName" },
      { text: "Current Half", value: "DuesPaidTxt" },
      { text: "Contact Info", value: "ContactInfo" },
      { text: "Aadhaar Verification Status", value: "AadhaarVerifiedTxt" },
      { text: "DOB", value: "MemberDob" }
      // { text: "Email", value: "EmailId" },
      // { text: "Address", value: "AddressTxt" }
      //   { text: "Actions", value: "actions" }
    );
    this.tableColumns2.push(
      { text: "#", value: "sno" },
      { text: "Photo", value: "ProfilePic" },
      { text: "Member Id", value: "MembershipId" },
      { text: "Member Name", value: "MemberName" },
      { text: "Current Half", value: "DuesPaidTxt" },
      { text: "Contact Info", value: "ContactInfo" },
      { text: "Aadhaar Verification Status", value: "AadhaarVerifiedTxt" },
      { text: "DOB", value: "MemberDob" }

      // { text: "Email", value: "EmailId" },
      // { text: "Address", value: "AddressTxt" }
      // { text: "Actions", value: "actions" }
    );
  },
};
</script>
<style lang="scss">
$navy: #3a67b1;
$aqua: #0097d7;
$white: #ffffff;

#members-subscrition-assign {

  // ── Speed Dial ──
  .v-btn--floating {
    position: relative;
  }

  .v-speed-dial--bottom {
    bottom: 12%;
  }

  .v-speed-dial--right {
    right: 5%;
  }

  // ── HEADER CARD ──────────────────────────────
  .header-card {
    background: linear-gradient(135deg, $navy 0%, $aqua 50%, $navy 100%) !important;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.45), 0 0 40px rgba(0, 151, 215, 0.25);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
      animation: shimmer 3s infinite;
    }

    .header-backdrop-effect {
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.12) 0%, transparent 70%);
      animation: rotate 25s linear infinite;
    }

    .header-content {
      position: relative;
      z-index: 2;
    }
  }

  .header-icon-box {
    background: rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(12px);
    border-radius: 18px;
    padding: 14px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    flex-shrink: 0;
  }

  .header-title {
    font-size: 28px;
    font-weight: 900;
    letter-spacing: 0.5px;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  }

  .header-subtitle {
    font-size: 14px;
    opacity: 0.9;
    font-weight: 500;
  }

  .action-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.35) !important;
    backdrop-filter: blur(10px);
    color: white !important;
    border-radius: 14px !important;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    font-size: 13px;
    transition: all 0.25s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.28) !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18) !important;
    }
  }

  // ── SECTION TITLE BAR ─────────────────────────
  .section-title-bar {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    color: $navy;
    background: #E8EAF6;
    border-left: 5px solid $aqua;
    border-radius: 8px;
    padding: 10px 16px;
  }

  // ── STAT CARDS ────────────────────────────────
  .stat-card {
    display: flex;
    align-items: center;
    gap: 18px;
    border-radius: 18px;
    padding: 22px 24px;
    color: white;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    transition: transform 0.25s ease, box-shadow 0.25s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
    }

    &.stat-paid {
      background: linear-gradient(135deg, #c62828, #ef5350);
    }

    &.stat-selected {
      background: linear-gradient(135deg, #2e7d32, #43a047);
    }

    &.stat-remaining {
      background: linear-gradient(135deg, #e65100, #ff8f00);
    }

    .stat-icon-wrap {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 14px;
      padding: 12px;
      flex-shrink: 0;
    }

    .stat-number {
      font-size: 40px;
      font-weight: 900;
      line-height: 1;
    }

    .stat-label {
      font-size: 13px;
      font-weight: 600;
      opacity: 0.9;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  // ── NOTES CARD ────────────────────────────────
  .notes-card {
    background: #F8F9FF;
    border: 1px solid #C5CAE9;
    border-radius: 14px;
    padding: 18px 22px;

    .notes-header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    .notes-title {
      font-size: 16px;
      font-weight: 700;
      color: $navy;
    }

    .notes-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: flex;
        align-items: flex-start;
        padding: 5px 0;
        font-size: 14px;
        color: #37474F;
        line-height: 1.6;
      }
    }
  }

  // ── TABS ──────────────────────────────────────
  .premium-tabs {
    border-radius: 14px 14px 0 0;

    .v-tab {
      font-weight: 700;
      font-size: 13px;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
  }

  // ── TAB CONTENT ───────────────────────────────
  .tab-content-card {
    border-radius: 0 0 14px 14px;
    padding: 20px;
    background: #FAFBFF;
  }

  .tab-section-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    color: $navy;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 2px solid #E8EAF6;
  }

  .table-count-bar {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #455A64;
    margin-bottom: 12px;
    padding: 8px 14px;
    background: #ECF0FA;
    border-radius: 8px;
  }

  .search-field {
    border-radius: 10px;

    .v-input__slot {
      background: white !important;
    }
  }

  // ── PREMIUM TABLE ─────────────────────────────
  .premium-table {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #E0E0E0;

    .v-data-table__wrapper>table>thead>tr>th {
      background: $navy !important;
      color: white !important;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      padding: 14px 16px;
    }

    .v-data-table__wrapper>table>tbody>tr {
      transition: background 0.15s ease;

      &:hover {
        background: #E8EAF6 !important;
      }

      &>td {
        font-size: 14px;
        padding: 12px 16px;
        border-bottom: 1px solid #F0F0F0;
      }
    }
  }

  // ── MEMBER NAME CELL ─────────────────────────
  .member-name-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .member-name-text {
    font-weight: 600;
    color: #1A237E;
    font-size: 14px;
  }

  .age-warning-chip {
    display: inline-flex;
    align-items: center;
    background: #E53935;
    color: white;
    border-radius: 6px;
    padding: 2px 8px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;
    width: fit-content;
  }

  // ── EMPTY STATE ───────────────────────────────
  .empty-state {
    text-align: center;
    padding: 48px 24px;
  }

  // ── NEW MEMBER TABLE ──────────────────────────
  .new-member-table {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #E0E0E0;

    thead tr th {
      background: $navy;
      color: white;
      font-size: 13px;
      font-weight: 700;
      padding: 12px 16px;
    }

    tbody .new-member-row:hover {
      background: #E8EAF6;
    }

    tbody tr td {
      padding: 12px 16px;
      font-size: 14px;
    }
  }

  // ── PREMIUM FOOTER ────────────────────────────
  .premium-footer {
    background: linear-gradient(90deg, $navy 0%, $aqua 50%, $navy 100%) !important;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.25);

    .footer-inner {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 28px;
      gap: 16px;
      flex-wrap: nowrap;
      min-height: 62px;
    }

    // Centered stats strip
    .footer-stats-row {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 6px 4px;
    }

    .footer-stat {
      display: inline-flex;
      align-items: center;
      flex-wrap: nowrap;
      color: rgba(255, 255, 255, 0.92);
      font-size: 15px;
      font-weight: 600;
      cursor: pointer;
      white-space: nowrap;
      padding: 6px 14px;
      border-radius: 22px;
      transition: background 0.2s ease;
      line-height: 1.2;

      strong {
        display: inline;
        white-space: nowrap;
        margin-left: 4px;
        font-size: 16px;
      }

      .v-icon {
        flex-shrink: 0;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.15);
        color: white;
      }

      &.total {
        color: #FFD54F;
        font-weight: 700;
        font-size: 15px;
        background: rgba(255, 213, 79, 0.12);
        border: 1px solid rgba(255, 213, 79, 0.35);
      }
    }

    .footer-divider {
      color: rgba(255, 255, 255, 0.35);
      font-size: 16px;
      font-weight: 300;
      user-select: none;
      flex-shrink: 0;
    }

    .submit-btn {
      flex-shrink: 0;
      border-radius: 12px;
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.5px;
      padding: 0 24px;
      height: 44px;
      background: linear-gradient(135deg, #2e7d32, #43a047) !important;
      box-shadow: 0 4px 14px rgba(67, 160, 71, 0.45);
      transition: box-shadow 0.2s ease, transform 0.2s ease;

      &:hover {
        box-shadow: 0 8px 24px rgba(67, 160, 71, 0.6);
        transform: translateY(-1px);
      }
    }
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(100%);
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  // ── Age-Restricted Row ─────────────────────────────────
  .row-age-restricted {
    background-color: rgba(244, 67, 54, 0.04) !important;
    opacity: 0.65;
    cursor: not-allowed !important;
    pointer-events: none; // blocks all clicks on the row

    td {
      color: #9e9e9e !important;
    }

    // Re-enable pointer events only on the checkbox cell so it shows the
    // "disabled" cursor/tooltip, but the @input guard blocks selection
    td:first-child {
      pointer-events: auto;
      cursor: not-allowed !important;
    }
  }
}
</style>